<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <access-key-list
          v-bubble.error
          v-bubble.info
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccessKeyList from '../components/AccessKeyList.vue'

export default {
  name: 'AdminAccessKeyView',

  components: {
    AccessKeyList
  }
}
</script>
